/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $SuspendedPlayerCreate = {
    properties: {
        name: {
            type: 'string',
            isRequired: true,
        },
        communicatoDate: {
            type: 'string',
            isRequired: true,
            format: 'date',
        },
        cause: {
            type: 'WarningCauseEnum',
            isRequired: true,
        },
        duration: {
            type: 'any-of',
            contains: [{
                type: 'number',
            }, {
                type: 'null',
            }],
        },
        untilDate: {
            type: 'any-of',
            contains: [{
                type: 'string',
                format: 'date',
            }, {
                type: 'null',
            }],
        },
        teamId: {
            type: 'number',
            isRequired: true,
        },
        matchId: {
            type: 'number',
            isRequired: true,
        },
    },
} as const;
